import renting_preparation_product_config from "@/components/RentingPreparationProduct/config";

export default {
  storeNamespace: 'renting',
  authFeature: 'renting',
  listRouteName: "RentingList",
  newRouteName: "RentingNew",
  editRouteName: "RentingEdit",
  detailRouteName: "RentingDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'RentingForm',
  csvExportFilenamePrefix: 'commandes',
  titleField: 'renting_number',
  sortBy: 'renting_number',
  sortDesc: true,
  editCondition: item => item ? item.raw_status_slug != 'renting-terminee' && item.raw_status_slug != 'renting-annulee' && item.status != 'Expédiée' && item.status != 'Annulée' : false,
  deleteCondition: item => item ? item.raw_renting_type_slug == 'office' : false,
  // Longue durée (SFD 2.8) : une commande engagée dont le prix négocié n'est pas saisi attend une
  // action — elle ne peut pas partir en préparation. Signalée dans la liste plutôt que découverte
  // au refus d'affectation d'un préparateur.
  rowClass: (item, type) => (type === 'row' && item && item.long_term_price_missing) ? 'table-warning' : null,
  fields: [{
    name: 'renting_number',
    label: "Numéro",
    type: 'text',
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
  },
  {
    name: 'axiloc_creation_date',
    label: "Date de création",
    type: 'date',
    inForm: false,
    inList: true,
    sortable: true,
    extendedFilter: true,
    filterWidth: 'half',
    filterOrder: 1,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    // INC-001 : filtre entrepôt (commandes ayant une préparation sur cet entrepôt).
    // Affiché uniquement aux utilisateurs sans entrepôt rattaché (cf. RentingList.vue).
    name: 'warehouse',
    label: "Entrepôt",
    type: 'select',
    extendedFilter: true,
    filterWidth: 'third',
    filterOrder: 3,
  },
  {
    name: 'agency_number',
    label: "Agence",
    type: 'chosen',
    inForm: true,
    required: true,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'agency_number',
    label: "N° Agence",
    inCsvExport: true,
    formatter: (context, value, item) => item && item.agency && item.agency.internal_number ? item.agency.internal_number : null
  },
  {
    name: 'agency',
    label: "Agence",
    type: 'select',
    inForm: false,
    inList: false,
    sortable: false,
    filterIn: false,
    inDetail: false,
    inCsvExport: true,
    inPdfExport: false,
    formatter: (context, value) => value && value.name ? value.name : null
  },
  {
    name: 'agency_fullname',
    label: "Agence",
    type: 'select',
    inDetail: true,
    inPdfExport: true
    },
  {
    name: 'agency_fullname',
    label: "Agence",
    type: 'select',
    inDetail: true,
    inPdfExport: false,
    formatter: (context, value, item) => item && item.agency && item.agency.internal_number && item.agency.name ? item.agency.internal_number + ' - ' + item.agency.name : null
  },
  {
    name: 'business_number',
    label: "Affaire",
    type: 'chosen',
    inForm: true,
    required: false,
    firstOption: "-- Sélectionnez une agence --",
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'business_fullname',
    label: "Affaire",
    type: 'select',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: false,
    inPdfExport: false,
    formatter: (context, value, item) => {
      return item
    }
  },
  {
    name: 'business_fullname',
    label: "Affaire",
    type: 'select',
    inForm: false,
    inList: false,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inPdfExport: true,
    formatter: (context, value, item) => {
      return  item && item.business && item.business.number && item.business.name ? item.business.number + ' - ' + item.business.name : null
    }
  },
  {
    name: 'business_number',
    label: "N° Affaire",
    inCsvExport: true,
    formatter: (context, value, item) => item && item.business.number ? item.business.number : null
  },
  {
    name: 'business_name',
    label: "Affaire",
    inCsvExport: true,
    formatter: (context, value, item) => item && item.business.name ? item.business.name : null
  },
  {
    name: 'wished_delivery_date',
    label: "Date de livraison souhaitée",
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null,
  },
  {
    name: 'shipping_date',
    label: "Date d'expédition",
    inCsvExport: true,
    formatter: (context, value, item) => {
      if (item && item.status && item.status == 'Expédiée' && item.renting_preparations && item.renting_preparations.length) {
        var dates = item.renting_preparations.map(renting_preparation => renting_preparation.shipping && renting_preparation.shipping.shipping_date ? context.$moment(renting_preparation.shipping.shipping_date).format("DD-MM-YYYY") : null);
        return [...new Set(dates)].join(", ");
      }
    }
  },
  {
    name: 'end_renting_date',
    label: "Date de fin de location estimée",
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null,
  },
  {
    name: 'references',
    label: "Liste matériels",
    inCsvExport: true,
    formatter: (context, value, item) => {
      var list = item.renting_preparations && item.renting_preparations.length
                ? item.renting_preparations.map(prepa => {
                    var references = prepa.renting_preparation_reference && prepa.renting_preparation_reference.length ? prepa.renting_preparation_reference.map(rpr => rpr.internal_code) : null;
                    var products = prepa.products_selling && prepa.products_selling.length ? prepa.products_selling.map(rpp => rpp.product.internal_code) : null;
                    if(references && references.length && products && products.length){
                      return [...references, ...products]
                    }else if(references && references.length){
                      return references
                    }else if(products && products.length){
                      return products
                    }
                  }).filter(item => item != null)
                : null
      if(list){
        if(list.length > 1){
          return list.join(', ')
        }else{
          return list[0]
        }
      }else{
        return null
      }
    }
  },
  {
    name: 'services',
    label: "Services",
    inCsvExport: true,
    filter: (context, filter_value, item_value, item) => item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == filter_value).length > 0,
    formatter: (context, value, item) => {
      var services = [];
      if (item) {
        if (item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == 'outillage').length) {
          services.push('outillage')
        }
        if (item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == 'instruments').length) {
          services.push('instruments')
        }
        if (item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == 'service_et_logistique').length) {
          services.push('service_et_logistique')
        }
      }
      return services.map(service => context.$store.getters['renting_preparation/getGroup'](service).text).join(', ')
    }
  },
  {
    name: 'employee_number',
    label: "Utilisateur des produits",
    type: 'vueselect',
    inForm: true,
    required: false,
    placeholder: "-- Sélectionnez une agence --",
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'employee',
    label: "Utilisateur des produits",
    type: 'select',
    inForm: false,
    inList: true,
    filterIn: true,
    sortable: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value && value.firstname && value.lastname && value.number ? value.firstname + ' ' + value.lastname + ' (' + value.number + ')' : null,
    description: "Personnel du groupe qui sera l'utilisateur des produits commandés. Il s'agit de la liste des employés"
  },
  {
    name: 'user',
    label: "Demandeur",
    inDetail: true,
    inPdfExport: true,
    inCsvExport: true,
    formatter: (context, value) => value && value.firstname && value.lastname ? value.firstname + ' ' + value.lastname : null
  },
  {
    name: 'user_id',
    label: "Demandeur",
    type: 'vueselect',
    inForm: true,
    required: true,
    description: "Utilisateur E-MATERIEL pouvant passer une commande. Il s'agit de la liste des utilisateurs."
  },
  {
    name: 'asker_email',
    label: "Email du demandeur",
    type: 'email',
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value, item) => item && item.user && item.user.email ? item.user.email : (value ? value : null)
  },
  {
    name: 'asker_number',
    label: "Matricule du demandeur",
    type: 'text',
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value, item) => item && item.user && item.user.employee && item.user.employee.number ? item.user.employee.number : (value ? value : null)
  },
  // Form de création
  {
    name: 'wished_delivery_date',
    label: "Date de livraison souhaitée",
    type: 'date',
    disabledDates: {
      to: new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate())
    },
    inForm: true,
    inFormCondition: (form) => !form.id,
    required: true,
    inList: true,
    sortable: true,
    extendedFilter: true,
    filterWidth: 'half',
    filterOrder: 2,
    inDetail: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null,
  },
  {
    name: 'end_renting_date',
    label: "Date de fin de location estimée",
    type: 'date',
    disabledDates: {
      to: new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate())
    },
    inForm: true,
    inFormCondition: (form) => !form.id,
    inDetail: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null,
  },
  // Form de modif
  {
    name: 'wished_delivery_date',
    label: "Date de livraison souhaitée",
    type: 'date',
    inForm: true,
    inFormCondition: (form) => form.id,
    required: true,
  },
  {
    name: 'end_renting_date',
    label: "Date de fin de location estimée",
    type: 'date',
    inForm: true,
    inFormCondition: (form) => form.id,
  },
  {
    // Le libellé nommait l'agence en dur, du temps de l'entrepôt unique. Le site de retrait
    // se choisit désormais dans le champ suivant (INC-005).
    name: 'withdrawed_at_agency',
    label: "Enlèvement à l'entrepôt",
    type: 'yesno',
    inForm: true,
    required: true,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
  },
  {
    name: 'withdrawal_warehouse_id',
    label: "Entrepôt de retrait",
    type: 'select',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == true,
    inList: false,
    filterIn: false,
  },
  {
    name: 'renting_retrieving_place',
    label: "Mode de livraison",
    type: 'select',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inDetail: true,
    inCsvExport: true,
  },
  {
    name: 'renting_retrieving_place',
    label: "Mode de livraison",
    type: 'select',
    inPdfExport: true,
    formatter: (context, value, item) => item.withdrawed_at_agency == 1
    ? {text: "Retrait direct à l'entrepôt ESM", background: '#1AAE7C'}
    : {text: context.$store.getters['renting/getRentingRetrievingPlaceBySlug'](item.renting_retrieving_place), background: context.$store.getters['renting/getRentingRetrievingPlaceColorBySlug'](item.renting_retrieving_place)}
  },
  {
    name: 'delivery_place',
    label: "Nom du lieu (agence/chantier/autre)",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'delivery_address',
    label: "Adresse de livraison",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'zip_code',
    label: "code postal",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'city',
    label: "Ville",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'first_contact_name',
    label: "Nom du premier contact",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'first_contact_phone',
    label: "Téléphone du premier contact",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'second_contact_name',
    label: "Nom du second contact",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'second_contact_phone',
    label: "Téléphone du second contact",
    type: 'text',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'required_truck_tailgate',
    label: "Camion à hayon requis",
    type: 'yesno',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'reachable_by_semitrailer_truck',
    label: "Accessible en semi-remorque",
    type: 'yesno',
    inForm: true,
    required: true,
    inFormCondition: (form) => form.withdrawed_at_agency == false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'comment',
    label: "Commentaire",
    type: 'textarea',
    inForm: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'status',
    label: "Statut",
    type: 'select',
    inForm: false,
    inList: true,
    tabFilter: true,
    tabFilterDefaultValue: 'renting-non-prise-en-compte',
    key: 'status_slug',
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? value.name : null
  },
  { // Ce champ sert juste à la condition sur le edit
    name: 'raw_status_slug',
    inDetail: true,
    formatter: (context, value, item) => item && item.status ? item.status.status_slug : null
  },
  {
    name: 'renting_type_slug',
    label: "Type",
    type: 'select',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$store.getters['renting/getType'](value) ? context.$store.getters['renting/getType'](value).text : null : null
  },
  { // Ce champ sert juste à la condition sur le edit et delete
    name: 'raw_renting_type_slug',
    inDetail: true,
    formatter: (context, value, item) => item ? item.renting_type_slug : null
  },
  {
    name: 'days_before_shipped',
    label: "Durée de traitement",
    inDetail: true,
    type: 'select',
    extendedFilter: true,
    filterWidth: 'third',
    filterOrder: 4,
    // filter: (context, filter_value, item_value) => item_value && ((filter_value == 1 && item_value >= 0 && item_value <= 1) || (filter_value == 2 && item_value >= 2 && item_value <= 4) || (filter_value == 3 && item_value >= 5)),
  },
  {
    name: 'services',
    label: "Services",
    type: 'select',
    inList: true,
    extendedFilter: true,
    filterWidth: 'third',
    filterOrder: 5,
    // filter: (context, filter_value, item_value, item) => item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == filter_value).length > 0,
    formatter: (context, value, item) => {
      var services = [];
      if (item) {
        if (item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == 'outillage').length) {
          services.push('outillage')
        }
        if (item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == 'instruments').length) {
          services.push('instruments')
        }
        if (item.renting_preparations && typeof item.renting_preparations === 'object' && item.renting_preparations.filter(item => item.group_slug == 'service_et_logistique').length) {
          services.push('service_et_logistique')
        }
      }
      return services
    }
  },
  {
    // Filtre seul : commandes d'échange (CM…-E) ou standard (SFD Échanges et stockage 1.1).
    name: 'type',
    label: "Type",
    type: 'select',
    inForm: false,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    extendedFilter: true,
    filterWidth: 'third',
    filterOrder: 8,
  },
  {
    // Filtre seul (dernière position) : origine de la commande, via une préparation
    // group_slug = 'mcs' (posée par l'import).
    name: 'from_mcs',
    label: "Origine",
    type: 'select',
    inForm: false,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    extendedFilter: true,
    filterWidth: 'third',
    filterOrder: 6,
  },
  {
    // Longue durée (SFD 2.8) : durée d'engagement de la commande, reprise de ses lignes.
    // Une commande peut porter plusieurs engagements de durées différentes.
    name: 'long_term',
    label: "Engagement",
    inList: true,
    inDetail: false,
    inCsvExport: true,
    inPdfExport: false,
    formatter: (context, value, item) => {
      const months = (item && item.long_term_months) || [];
      if (!months.length) {
        return null;
      }
      return months.map((m) => m + " mois").join(", ");
    }
  },
  {
    // Filtre seul : le champ `long_term` ci-dessus porte l'affichage, celui-ci le critère.
    // Deux entrées distinctes car un champ ne peut pas à la fois formater une valeur de ligne
    // et servir de modèle de filtre.
    name: 'long_term_filter',
    label: "Engagement",
    type: 'select',
    inForm: false,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    extendedFilter: true,
    filterWidth: 'third',
    filterOrder: 7,
  },
  {
    name: 'shipping_date',
    label: "Date d'expédition",
    inList: true,
    inDetail: true,
    formatter: (context, value, item) => {
      if (item && item.status && item.status.status_slug == 'renting-terminee' && item.renting_preparations && item.renting_preparations.length) {
        var dates = item.renting_preparations.map(renting_preparation => renting_preparation.shipping && renting_preparation.shipping.shipping_date ? context.$moment(renting_preparation.shipping.shipping_date).format("DD-MM-YYYY") : null);
        return [...new Set(dates)].join(", ");
      }
    }
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inForm: false,
    inList: false,
    inDetail: true,
    inPdfExport: false,
    formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
  },
  {
    name: 'products',
    label: "Produits",
    type: 'group_repeater',
    inForm: true,
    inFormCondition: (form) => !form.id,
    fields: [{
      name: 'product_id',
      label: "Produit",
      type: 'chosen',
      inForm: true,
    },
    {
      name: 'quantity',
      label: "Quantité",
      type: 'number',
      inForm: true,
    },
    ]
  },
  ],
  submitFormatter: function (form, context) {
    // On ajoute les produits à la vente dans la propriété products pour la soumission
    var products = _.cloneDeep(context.$store.getters['product/getAll'])
    return {
      ...form,
      products: [
        ...form.products.map(product => ({
          product_id: product.product_id,
          quantity: product.quantity,
          sale_price: products && products.find(item => item.id == product.product_id) ? products.find(item => item.id == product.product_id).sale_price : null
        }))
      ]
    }
  },
  pdf_export_extra_content_before: function (rawValues, values, context) {
    return [{
      table: {
        widths: ["*", "*"],
        body: [
          ['Date de livraison souhaitée :', {
            text: context.$moment(rawValues.wished_delivery_date).format("DD-MM-YYYY"),
            fontSize: 14,
            bold: true
          }]
        ]
      },
      layout: 'noBorders'
    }]
  },
  pdf_export_extra_lists: function (rawValues, values, context) {
    var datas = {
      instruments: [],
      outillage: [],
      service_et_logistique: []
    }

    let lots = []

    rawValues.renting_preparations.forEach(renting_preparation => {
      if (renting_preparation.products_renting) {
        datas[renting_preparation.group_slug].push(...renting_preparation.products_renting.map(
          item => [item.product.name, item.quantity]
          ))
        }
        if (renting_preparation.products_selling) {
          datas[renting_preparation.group_slug].push(...renting_preparation.products_selling.map(item => {

            // On traite séparément les produits enfant de lot
            if (item.hasOwnProperty('lot')) {
              if (lots.hasOwnProperty(item.lot) !== true) {
                lots[item.lot] = {
                  name      : context.$store.getters["product/getItem"](item.product_parent_id) ? context.$store.getters["product/getItem"](item.product_parent_id).name : null,
                  group_slug: renting_preparation.group_slug,
                  products  : []
                }
              }
              lots[item.lot].products.push([item.product.name, item.quantity])
            } else {
              return [item.product.name, item.quantity]
            }
          }
        ))
      }
    })

    var lists = []
    if (datas.instruments.length) {
      let list = {
        label: context.$store.getters["renting_preparation/getGroup"](
          'instruments'
        ).text,
        infos: [
          renting_preparation_product_config.fields
            .filter(field => ["product", "quantity"].includes(field.name))
            .map(field => field.label),
          ...datas.instruments.filter(item => item != null)
        ]
      };
      lists.push(list);
    }
    if (datas.outillage.length) {
      let list = {
        label: context.$store.getters["renting_preparation/getGroup"](
          'outillage'
        ).text,
        infos: [
          renting_preparation_product_config.fields
            .filter(field => ["product", "quantity"].includes(field.name))
            .map(field => field.label),
          ...datas.outillage.filter(item => item != null)
        ]
      };
      lists.push(list);
    }
    if (datas.service_et_logistique.length) {
      let list = {
        label: context.$store.getters["renting_preparation/getGroup"](
          'service_et_logistique'
        ).text,
        infos: [
          renting_preparation_product_config.fields
            .filter(field => ["product", "quantity"].includes(field.name))
            .map(field => field.label),
          ...datas.service_et_logistique.filter(item => item != null)
        ]
      };
      lists.push(list);
    }

    // Ajout des lots sous forme de liste dans le PDF
    if (lots) {
      lots.map(lot => {
        let list = {
          label: context.$store.getters["renting_preparation/getGroup"](
            lot.group_slug
          ).text + " - " + lot.name,
          infos: [
            renting_preparation_product_config.fields
              .filter(field => ["product", "quantity"].includes(field.name))
              .map(field => field.label),
            ...lot.products
          ]
        };
        lists.push(list);
      })
    }

    return lists;
  },
}



// WEBPACK FOOTER //
// ./src/components/Renting/config.js